import {
  Column,
  DataDisplayType,
} from '@navstation-portal/reporting/data-model/ui';

export const cols: Column[] = [
  { field: 'reportNumber', header: '#', type: DataDisplayType.Integral },
  { field: 'reportFrom', header: 'Report From', type: DataDisplayType.Date },
  { field: 'reportTo', header: 'Report To', type: DataDisplayType.Date },
  {
    field: 'reportPeriod',
    header: 'Report Period',
    type: DataDisplayType.Integral,
  },
  {
    field: 'event',
    header: 'Event',
    type: DataDisplayType.String,
  },
  {
    field: 'operation',
    header: 'Operation',
    type: DataDisplayType.String,
  },
  { field: 'status', header: 'Status', type: DataDisplayType.Icon },
];
